module.exports = __webpack_public_path__ + "img/contentImgHover3.e120d04.webp";